import { networkStatusNotifier } from '../networkStatusNotifier'

export const networkStatusLink = networkStatusNotifier.link
